import { ReactNode } from 'react';
import './SidebarLayout.css';

const SidebarLayout = ({ children }: { children: ReactNode }) => (
  <div className='sidebar-layout'>
    {children}
  </div>
);

export default SidebarLayout;